export const Logout = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8333 7.33329V5.49996C12.8333 5.01373 12.6402 4.54741 12.2964 4.2036C11.9525 3.85978 11.4862 3.66663 11 3.66663H4.58333C4.0971 3.66663 3.63079 3.85978 3.28697 4.2036C2.94315 4.54741 2.75 5.01373 2.75 5.49996V16.5C2.75 16.9862 2.94315 17.4525 3.28697 17.7963C3.63079 18.1401 4.0971 18.3333 4.58333 18.3333H11C11.4862 18.3333 11.9525 18.1401 12.2964 17.7963C12.6402 17.4525 12.8333 16.9862 12.8333 16.5V14.6666"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41675 11H19.2501M19.2501 11L16.5001 8.25M19.2501 11L16.5001 13.75"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
